/* --depict-theme-resource-version: v1
   Depict Recommendations — all carousel/drawer/quick-add JS for every placement.

   Lives in an asset (loaded by snippets/depict-recommendations.liquid from
   every placement) instead of section javascript tags: Shopify compiles
   section javascript into scripts.js gated per page by section type
   (`__sections__[...]`), so a section's JS does NOT run on pages where only a
   sibling Depict section is present. Section stylesheet tags have no such
   gating and stay in the section files. */
(function () {
  if (window.__depictRecsJs) return;
  window.__depictRecsJs = 1;

  /* "/" on the primary locale, "/fr-fr/" in a language subfolder. Root-relative
     paths without it serve the primary language. */
  function rootUrl() {
    return (window.themeJs && window.themeJs.rootUrl) || '/';
  }

  // The theme's own carousel arrows (frame.js Dn()).
  var NAV_TEXT = [
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 7L9 12L14 17V7Z" fill="black"/></svg>',
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 17L15 12L10 7V17Z" fill="black"/></svg>'
  ];

  /* Retries owl init until jQuery + owl have loaded and the grid is visible
     (sections stay display:none until the Depict extension's reveal CSS
     applies; owl measures widths at init). */
  function whenInitable(sectionEl, grid, init) {
    function tryInit() {
      if (sectionEl.dataset.depictInit === '1') return true;
      if (!(window.jQuery && jQuery.fn && jQuery.fn.owlCarousel)) return false;
      if (!grid.clientWidth) return false;
      sectionEl.dataset.depictInit = '1';
      init();
      return true;
    }
    if (tryInit()) return;
    var observer = new ResizeObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(grid);
    // The observer covers the reveal; this covers jQuery/owl loading late.
    var tries = 0;
    var timer = setInterval(function () {
      if (tryInit() || ++tries >= 100) clearInterval(timer);
    }, 250);
  }

  /* Inline placements (PDP/home/collection). Same config the theme applies
     to #ProductRecommendations, with item counts from the section settings.
     Feature-collection-style placements (data-depict-dots / data-depict-loop
     on the grid) get the dots and looping the theme's own feature-collection
     carousels run with. */
  function initSection(section) {
    if (section.dataset.depictInit === '1') return;
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    var dots = 'depictDots' in grid.dataset;
    var loop = 'depictLoop' in grid.dataset;
    whenInitable(section, grid, function () {
      jQuery(grid).owlCarousel({
        nav: false,
        dots: dots,
        items: Number(grid.dataset.itemsMobile) || 2,
        rewind: loop,
        loop: loop,
        margin: 8,
        autoplayTimeout: 10000,
        autoplaySpeed: 400,
        autoplayHoverPause: true,
        navText: NAV_TEXT,
        responsive: {
          992: {
            dots: dots,
            items: Number(grid.dataset.itemsDesktop) || 4,
            margin: 56,
            nav: true
          }
        }
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section:not(.depict-rec-drawer)').forEach(initSection);
  }

  /* Cart drawer placement. The theme's cart drawer is mounted client-side
     (frame.js appends a Vue-rendered .cart-drawer to <body> on every open and
     removes it on close), so the server-rendered block is "parked" hidden on
     the page and cloned into the drawer each time it opens. */
  function initDrawerCarousel(sectionEl) {
    var grid = sectionEl.querySelector('[data-depict-drawer-grid]');
    if (!grid) return;
    // Same config frame.js Gn() applies to the native cart-recommendations
    // carousel: 2 items / dots on mobile, data-items-desktop / margin 16 /
    // arrows on desktop, no loop.
    whenInitable(sectionEl, grid, function () {
      jQuery(grid).owlCarousel({
        nav: false,
        dots: true,
        items: 2,
        rewind: false,
        loop: false,
        margin: 10,
        autoplayTimeout: 10000,
        autoplaySpeed: 400,
        autoplayHoverPause: true,
        navText: NAV_TEXT,
        responsive: {
          992: {
            dots: false,
            items: Number(grid.dataset.itemsDesktop) || 3,
            margin: 16,
            nav: true
          }
        }
      });
    });
  }

  function injectInto(drawerRoot) {
    var parked = document.querySelector('[data-depict-drawer-park] > .depict-rec-drawer');
    if (!parked) return;
    // display stays 'none' until the Depict extension's reveal CSS is active;
    // don't inject dead markup when the app embed is off.
    if (getComputedStyle(parked).display === 'none') return;

    var container = drawerRoot.querySelector('[js-cart-drawer="container"]');
    if (!container || container.querySelector('.depict-rec-drawer')) return;

    var clone = parked.cloneNode(true);
    container.appendChild(clone);
    initDrawerCarousel(clone);

    // Vue appends late content (line items and the native recommendations
    // render once the cart fetch resolves); keep our block last so it stays
    // below the native recommendations until those are switched off.
    var keepLast = new MutationObserver(function () {
      if (!document.body.contains(container)) {
        keepLast.disconnect();
        return;
      }
      if (container.contains(clone) && container.lastElementChild !== clone) {
        container.appendChild(clone);
      }
    });
    keepLast.observe(container, { childList: true });
  }

  function watchForDrawer() {
    if (!document.querySelector('[data-depict-drawer-park]')) return;
    // The drawer root (.cart-drawer) is mounted as a direct child of <body>
    // on every open and removed on close.
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          var n = m.addedNodes[i];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains('cart-drawer')) {
            injectInto(n);
          } else if (n.querySelector) {
            var d = n.querySelector('.cart-drawer');
            if (d) injectInto(d);
          }
        }
      });
    });
    bodyObserver.observe(document.body, { childList: true });
    var existing = document.querySelector('.cart-drawer');
    if (existing) injectInto(existing);
  }

  /* ------------------------------------------------------------------------
     Quick add.

     The cards render the theme's own [js-quick-add="product"] button
     (product-card's show_form param, as complete-the-look uses). frame.js
     binds those buttons only on product pages that have a complete-the-look
     gallery, and its listener sits on the button itself, so it runs before
     this delegated one and its panel is already in the DOM when ours checks:
     wherever the theme handles the click we simply stand down.

     Everywhere else — collection, home, and the buttons cloned into the cart
     drawer — this rebuilds the same flow with the theme's own CSS classes
     and strings: the .product-quick-add slide-in with colour swatches (same
     storefront GraphQL lookup frame.js does), the size picker (incl. the bra
     back/cup split for "cup-size"-tagged products), size chart (the theme's
     global js-drawer handler), add via /cart/add.js, then the native cart
     drawer. Known divergence: for an out-of-stock selection we show the
     disabled SOLD OUT button; the native modal's NOTIFY ME back-in-stock
     signup is Vue-internal and not reproducible from here.
  ------------------------------------------------------------------------ */

  function qaStrings() {
    var t = window.themeJs;
    var s = (t && t.strings && t.strings.products && t.strings.products.product) || {};
    return {
      quickAdd: s.quickAdd || 'Quick add',
      seeFullInfo: s.seeFullInfo || 'See full product info',
      colour: s.colour || 'Colour',
      size: s.size || 'Size',
      amount: s.amount || 'Amount',
      backSize: s.backSize || 'Back size',
      cupSize: s.cupSize || 'Cup size',
      pleaseSelect: s.pleaseSelect || 'Please select',
      sizeChart: s.sizeChart || 'Size chart',
      chooseOptions: s.chooseOptions || 'Choose options',
      addToCart: s.addToCart || 'Add to cart',
      soldOut: s.soldOut || 'Sold out',
      cancel: s.cancel || 'Cancel'
    };
  }

  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }

  function emitCart(event) {
    if (window.Frame && Frame.EventBus) Frame.EventBus.emit(event);
  }

  // Mirrors frame.js ProductForm.openCartDrawer(); the header icon's click
  // handler does the actual Vue CartDrawer mount.
  function openNativeCartDrawer() {
    if (window.location.pathname === rootUrl() + 'cart') {
      emitCart('AjaxCart:requestUpdate');
      return;
    }
    if (document.querySelector('.cart-drawer.is-open')) {
      emitCart('AjaxCart:requestUpdate');
      var container = document.querySelector('[js-cart-drawer="container"]');
      if (container) container.scroll({ top: 0, behavior: 'smooth' });
      return;
    }
    var icon = document.querySelector('[js-cart-drawer="icon"]');
    if (icon) icon.click();
    else emitCart('AjaxCart:requestUpdate');
  }

  // Same lookup frame.js ProductQuickAdd.setColorSwatches() runs, minus the
  // fields the colour row doesn't use.
  var SWATCH_QUERY =
    'query($handle: String!, $country: CountryCode!, $language: LanguageCode!)' +
    ' @inContext(country: $country, language: $language) {' +
    ' product(handle: $handle) { available: availableForSale handle title' +
    ' metafields(identifiers: [{ namespace: "global", key: "product_card_swatch_color" }]) { key value } } }';

  function fetchSwatch(handle) {
    var sf = window.themeJs && themeJs.storefront;
    if (!sf || !sf.token || !handle) return Promise.resolve(null);
    return fetch('https://' + sf.store + '.myshopify.com/api/' + sf.version + '/graphql.json', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': sf.token
      },
      body: JSON.stringify({
        query: SWATCH_QUERY,
        variables: { handle: handle, country: sf.country, language: sf.language }
      })
    }).then(function (r) {
      return r.json();
    }).then(function (d) {
      var p = d && d.data && d.data.product;
      if (!p) return null;
      var mf = (p.metafields || []).filter(function (m) {
        return m && m.key === 'product_card_swatch_color';
      })[0];
      return { handle: p.handle, title: p.title, available: p.available, color: (mf && mf.value) || '' };
    }).catch(function () {
      return null;
    });
  }

  function openQuickAdd(btn) {
    var product, variants, handles, sizeGuides;
    try {
      product = JSON.parse(btn.dataset.product);
      variants = JSON.parse(btn.dataset.variants || '[]');
      handles = JSON.parse(btn.dataset.alternativeProductHandles || '[]') || [];
      // The attribute holds a JSON string; the size-guide drawer wants the
      // comma-separated value inside it, as frame.js parses it too.
      sizeGuides = JSON.parse(btn.dataset.sizeGuides || '""') || '';
    } catch (err) {
      return;
    }
    if (!product || !product.variants || !product.variants.length) return;

    var strings = qaStrings();
    var minStock = Number(btn.dataset.minStock) || 0;
    // Tagged, not titled: product titles are translatable, so matching the
    // English words only recognised a gift card on the English storefront.
    var isGiftCard = (product.tags || []).some(function (t) {
      return String(t) === 'gift-card';
    });
    var isBra = (product.tags || []).some(function (t) {
      return String(t).indexOf('cup-size') > -1;
    });

    var state = { selectedId: '', sizeText: '?', back: '?', cup: '?' };
    if (product.variants.length === 1) {
      state.selectedId = product.variants[0].id;
      state.sizeText = '';
    }

    function qty(id) {
      var v = variants.filter(function (x) { return x.id === id; })[0];
      return v ? v.inventory_quantity : 0;
    }
    function isOOS() {
      if (state.selectedId === '' || isGiftCard) return false;
      if (state.selectedId === 0) return true;
      return product.variants.some(function (v) {
        return v.id === state.selectedId && qty(v.id) <= minStock;
      });
    }

    // Bra sizes come from splitting option2 ("32B" -> back "32", cup "B"),
    // like frame.js getBraSizes(); a combo is buyable when its exact variant
    // exists above the low-stock threshold.
    var braBacks = [];
    var braCups = [];
    if (isBra) {
      product.variants.forEach(function (v) {
        var parts = String(v.option2 || '').split(/([0-9]+)/).filter(Boolean);
        if (parts[0] && braBacks.indexOf(parts[0]) === -1) braBacks.push(parts[0]);
        if (parts[1] && braCups.indexOf(parts[1]) === -1) braCups.push(parts[1]);
      });
    }
    function braVariant(back, cup) {
      return product.variants.filter(function (v) {
        return String(v.option2 || '').indexOf('' + back + cup) > -1;
      })[0];
    }
    function braComboAvailable(combo) {
      var exists = product.variants.some(function (v) { return v.option2 === combo; });
      if (!exists) return false;
      return !product.variants.some(function (v) {
        return v.option2 === combo && qty(v.id) <= minStock;
      });
    }

    var hadOpenDrawer = document.querySelectorAll('.drawer-component.is-open').length > 0;

    var root = el('div', 'product-quick-add drawer-component depict-quick-add');
    if (hadOpenDrawer) root.classList.add('no-background');
    root.addEventListener('click', function (e) {
      if (e.target === root) close();
    });

    var container = el('div', 'product-quick-add__container');
    root.appendChild(container);

    var closeBtn = el('div', 'product-quick-add__close');
    closeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#2B2B2B"/></svg>';
    closeBtn.addEventListener('click', close);
    container.appendChild(closeBtn);

    container.appendChild(el('h4', 'product-quick-add__header', strings.quickAdd));

    var productRow = el('div', 'product-quick-add__product');
    var img = document.createElement('img');
    img.src = (product.images && product.images[0]) || '';
    img.alt = product.title || '';
    productRow.appendChild(img);
    var details = el('div', 'product-quick-add__product--details');
    details.appendChild(el('p', null, product.title || ''));
    // The card already holds the price in the shopper's currency (the theme's
    // converter rewrites .money on load); reuse it rather than reformatting.
    var cardContainer = btn.closest('.product-card__container');
    var cardPrice = cardContainer && cardContainer.querySelector('.price-wrapper');
    if (cardPrice) details.appendChild(cardPrice.cloneNode(true));
    var link = el('a', null, strings.seeFullInfo);
    link.href = rootUrl() + 'products/' + product.handle;
    details.appendChild(link);
    productRow.appendChild(details);
    container.appendChild(productRow);

    var form = el('form', 'form-vertical');
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    var productForm = el('div', 'product-form');
    form.appendChild(productForm);
    container.appendChild(form);

    if (!isGiftCard) productForm.appendChild(buildColors());
    var sizesEl = el('div');
    productForm.appendChild(sizesEl);
    var buttonsEl = el('div', 'product-form__buttons');
    productForm.appendChild(buttonsEl);

    var cancelWrap = el('div', 'text-center');
    var cancelBtn = el('button', 'product-quick-add__cancel body-2', strings.cancel);
    cancelBtn.type = 'button';
    cancelBtn.addEventListener('click', close);
    cancelWrap.appendChild(cancelBtn);
    form.appendChild(cancelWrap);

    function close() {
      if (!hadOpenDrawer) document.documentElement.classList.remove('is-locked');
      root.classList.remove('is-open');
      setTimeout(function () { root.remove(); }, 200);
    }

    function sizeChartButton() {
      // The theme's document-level js-drawer handler opens the (globally
      // rendered) SizeGuidesDrawer, so this works from our modal untouched.
      var b = el('button', 'size-guides-trigger', strings.sizeChart);
      b.type = 'button';
      b.setAttribute('data-id', 'SizeGuidesDrawer');
      b.setAttribute('data-size-guides', sizeGuides);
      b.setAttribute('js-drawer', 'open');
      return b;
    }

    function sizeHeader(title, selectedText, withChart) {
      var header = el('div', 'product-form__sizes--header');
      header.appendChild(el('p', 'title', title));
      var isPlaceholder = selectedText === '?';
      header.appendChild(el(
        'p',
        'text--secondary ' + (isPlaceholder ? 'non-selected' : 'selected'),
        isPlaceholder ? strings.pleaseSelect : selectedText
      ));
      if (withChart) header.appendChild(sizeChartButton());
      return header;
    }

    function renderSizes() {
      sizesEl.innerHTML = '';
      if (product.variants.length <= 1) return;
      if (isBra) {
        [['back', strings.backSize, braBacks], ['cup', strings.cupSize, braCups]].forEach(function (group, gi) {
          var key = group[0];
          var wrap = el('div', 'product-form__sizes');
          wrap.appendChild(sizeHeader(group[1], state[key], gi === 0));
          var opts = el('div', 'product-form__sizes--options ' + key);
          group[2].forEach(function (opt) {
            var o = el('div', 'product-form__sizes--option', opt);
            var other = key === 'back' ? state.cup : state.back;
            var combo = key === 'back' ? opt + other : other + opt;
            if (other !== '?' && !braComboAvailable(combo)) o.classList.add('out-of-stock');
            if (state[key] === opt) o.classList.add('is-active');
            o.addEventListener('click', function () {
              state[key] = opt;
              if (state.back !== '?' && state.cup !== '?') {
                var v = braVariant(state.back, state.cup);
                state.selectedId = (v && v.id) || 0;
              }
              renderSizes();
              renderButtons();
            });
            opts.appendChild(o);
          });
          wrap.appendChild(opts);
          sizesEl.appendChild(wrap);
        });
      } else {
        var wrap = el('div', 'product-form__sizes' + (isGiftCard ? ' is-gift-card' : ''));
        wrap.appendChild(sizeHeader(isGiftCard ? strings.amount : strings.size, state.sizeText, !isGiftCard));
        var opts = el('div', 'product-form__sizes--options none-bra');
        product.variants.forEach(function (v) {
          var label = v.option2 || v.option1;
          var o = el('div', 'product-form__sizes--option', label);
          if (!v.available) o.classList.add('out-of-stock');
          if (isGiftCard) o.classList.add('is-gift-card');
          if (state.selectedId === v.id) o.classList.add('is-active');
          o.addEventListener('click', function () {
            state.selectedId = v.id;
            state.sizeText = label;
            renderSizes();
            renderButtons();
          });
          opts.appendChild(o);
        });
        wrap.appendChild(opts);
        sizesEl.appendChild(wrap);
      }
      addScrollHints();
    }

    /* The theme adds a small arrow when the options overflow the viewport
       (frame.js importMobileScrolling). */
    function addScrollHints() {
      if (window.innerWidth > 768 || isGiftCard) return;
      var groups = isBra
        ? ['.back .product-form__sizes--option', '.cup .product-form__sizes--option']
        : ['.none-bra .product-form__sizes--option'];
      groups.concat('.product-form__sizes--color').forEach(function (selector) {
        var options = root.querySelectorAll(selector);
        if (!options.length) return;
        var needed = (options[0].offsetWidth + 12) * options.length;
        if (window.innerWidth >= needed) return;
        var host = options[0].parentElement.parentElement;
        if (host.querySelector('.scroll-icon')) return;
        var icon = el('div', 'scroll-icon icon');
        icon.innerHTML = '<svg width="5" height="11" viewBox="0 0 5 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 10.9858L5 5.98584L0 0.98584V10.9858Z" fill="black"/></svg>';
        host.append(icon);
      });
    }

    function renderButtons() {
      buttonsEl.innerHTML = '';
      if (state.selectedId === '') {
        var choose = el('div', 'button');
        choose.appendChild(el('span', null, strings.chooseOptions));
        choose.addEventListener('click', function () {
          root.querySelectorAll('.product-form__sizes .non-selected').forEach(function (p) {
            p.classList.add('error');
          });
        });
        buttonsEl.appendChild(choose);
      } else if (isOOS() || product.available === false) {
        var soldOut = el('button', 'button main-addToCart', strings.soldOut);
        soldOut.disabled = true;
        soldOut.name = 'add';
        buttonsEl.appendChild(soldOut);
      } else {
        var add = el('button', 'button ctl-AddToCart');
        add.type = 'button';
        add.name = 'add';
        add.appendChild(el('span', null, strings.addToCart));
        add.addEventListener('click', addToCart);
        buttonsEl.appendChild(add);
      }
    }

    function addToCart(e) {
      var target = e.currentTarget;
      target.disabled = true;
      fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: state.selectedId, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('Depict quick add: /cart/add.js returned ' + r.status);
        return r.json();
      }).then(function () {
        // Same post-add sequence as the native modal: instant removal, GTM
        // event, then the drawer.
        root.remove();
        if (!document.querySelector('.cart-drawer.is-open')) {
          document.documentElement.classList.remove('is-locked');
        }
        emitCart('AjaxCart:sendGTMEvent');
        openNativeCartDrawer();
      }).catch(function (err) {
        target.disabled = false;
        if (window.console) console.error(err);
      });
    }

    function buildColors() {
      var wrap = el('div', 'product-form__colors');
      var header = el('div', 'product-form__sizes--header');
      header.appendChild(el('p', 'title', strings.colour));
      header.appendChild(el(
        'p',
        'selected text--secondary',
        (product.variants[0] && product.variants[0].option1) || ''
      ));
      wrap.appendChild(header);
      var opts = el('div', 'product-form__sizes--options colors');
      var current = colorLink(product.handle, product.title, '', product.available !== false);
      current.classList.add('is-active');
      opts.appendChild(current);
      opts.appendChild(el('div'));
      wrap.appendChild(opts);

      // Swatch colours (and the sibling colourways) load async, as in the
      // native modal.
      Promise.all([product.handle].concat(handles).map(fetchSwatch)).then(function (res) {
        var cur = res[0];
        if (cur && cur.color) {
          current.querySelector('.product-form__sizes--color-circle').style.backgroundColor = cur.color;
        }
        res.slice(1).filter(Boolean).forEach(function (alt) {
          opts.insertBefore(
            colorLink(alt.handle, alt.title, alt.color, alt.available),
            opts.lastElementChild
          );
        });
      });
      return wrap;
    }

    function colorLink(handle, title, color, available) {
      var a = el('a', 'product-form__sizes--color');
      if (!available) a.classList.add('out-of-stock');
      a.href = rootUrl() + 'products/' + handle;
      var circle = el('div', 'product-form__sizes--color-circle');
      if (color) circle.style.backgroundColor = color;
      a.appendChild(circle);
      a.appendChild(el('span', 'visually-hidden', title || ''));
      return a;
    }

    renderSizes();
    renderButtons();
    document.body.appendChild(root);
    document.documentElement.classList.add('is-locked');
    setTimeout(function () { root.classList.add('is-open'); }, 20);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[js-quick-add="product"]') : null;
    if (!btn || !btn.closest('.depict-rec-section')) return;
    // The theme's own handler, where it is bound, has already opened its panel.
    if (document.querySelector('.product-quick-add')) return;
    e.preventDefault();
    openQuickAdd(btn);
  });

  function start() {
    initAll();
    watchForDrawer();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: re-init when a section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
